// https://nextjs.org/docs/app/api-reference/functions/generate-metadata#link-relpreconnect
import ReactDOM from 'react-dom';
export var PreconnectResources = function PreconnectResources() {
  // @ts-ignore
  ReactDOM.preconnect('https://static.crehana.com', {
    crossOrigin: 'cors'
  });
  if (process.env.ASSET_PREFIX_CREHANA) {
    // @ts-ignore
    ReactDOM.preconnect(process.env.ASSET_PREFIX_CREHANA, {
      crossOrigin: ''
    });
  }
  return null;
};